import insertLink from './insertLink.js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var _insertLink = _interopRequireDefault(insertLink);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var handleLink = function handleLink(editorState, character) {
  var re = /\[([^\]]+)]\(([^)"]+)(?: "([^"]+)")?\)/g;
  var key = editorState.getSelection().getStartKey();
  var text = editorState.getCurrentContent().getBlockForKey(key).getText();
  var line = ''.concat(text).concat(character);
  var newEditorState = editorState;
  var matchArr;
  do {
    matchArr = re.exec(line);
    if (matchArr) {
      newEditorState = (0, _insertLink.default)(newEditorState, matchArr);
    }
  } while (matchArr);
  return newEditorState;
};
var _default = handleLink;
export default _default;
